import { captureSentryException } from "@/lib/sentryLazy";
import React from "react";

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Fehler an Sentry senden (extra statt contexts.react ist sauberer)
    captureSentryException(error, {
      componentStack: errorInfo.componentStack,
    });
    // Console-Error-Ausgabe deaktiviert (wie gewünscht)
    // console.error("ErrorBoundary caught an error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 32, textAlign: "center", color: "red" }}>
          <h2>Ein Fehler ist aufgetreten.</h2>
          <pre>{this.state.error?.message}</pre>
          <p>Bitte lade die Seite neu oder wende dich an den Support.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
